/* eslint-disable @typescript-eslint/no-explicit-any -- Supabase boundary; new tables not yet in generated types. See mem://preferences/lint-debt.md */
// Publication Destinations — per-publication "chip state" tracking.
//
// Each row records that a specific connector chip or manual chip has been
// pushed / dispatched / marked as sent for a given publication. The Publisher
// UI reads these to render checkmarks on chips.
//
// kind = "connector" → connector_id set, dispatch_id set after a successful push
// kind = "manual"    → manual_destination_id set, marked_sent_at set when the
//                      user toggles the chip's checkbox.

import { supabase } from "@/integrations/supabase/client";

export type PublicationDestinationKind = "connector" | "manual";

export type PublicationDestination = {
  id: string;
  publication_id: string;
  workspace_id: string;
  kind: PublicationDestinationKind;
  connector_id: string | null;
  manual_destination_id: string | null;
  dispatch_id: string | null;
  marked_sent_at: string | null;
  created_by_user_id: string;
  created_at: string;
  updated_at: string;
};

const TBL = "content_publication_destinations" as const;

export const listPublicationDestinations = async (
  workspaceId: string,
): Promise<PublicationDestination[]> => {
  const { data, error } = await (supabase as any)
    .from(TBL)
    .select("*")
    .eq("workspace_id", workspaceId);
  if (error) throw error;
  return (data ?? []) as PublicationDestination[];
};

export const recordConnectorDispatch = async (input: {
  workspaceId: string;
  publicationId: string;
  connectorId: string;
  dispatchId: string;
  createdByUserId: string;
}): Promise<void> => {
  const { error } = await (supabase as any).from(TBL).insert({
    workspace_id: input.workspaceId,
    publication_id: input.publicationId,
    kind: "connector",
    connector_id: input.connectorId,
    dispatch_id: input.dispatchId,
    marked_sent_at: new Date().toISOString(),
    created_by_user_id: input.createdByUserId,
  });
  if (error) throw error;
};

export const setManualChipMarked = async (input: {
  workspaceId: string;
  publicationId: string;
  manualDestinationId: string;
  marked: boolean;
  createdByUserId: string;
}): Promise<void> => {
  if (input.marked) {
    const { error } = await (supabase as any).from(TBL).insert({
      workspace_id: input.workspaceId,
      publication_id: input.publicationId,
      kind: "manual",
      manual_destination_id: input.manualDestinationId,
      marked_sent_at: new Date().toISOString(),
      created_by_user_id: input.createdByUserId,
    });
    if (error) throw error;
    return;
  }
  const { error } = await (supabase as any)
    .from(TBL)
    .delete()
    .eq("publication_id", input.publicationId)
    .eq("manual_destination_id", input.manualDestinationId);
  if (error) throw error;
};
